module.exports = __webpack_public_path__ + "img/logo-looker.325585df.webp";